/* eslint-disable no-unused-vars */
export enum LocalStorageItems {
	language = 'lng',
	sessionID = 'sessionID',
	isAuth = 'isAuth',
	userPermissions = 'userPermissions',
	client = 'client',
	wallets = 'wallets',
	currentAccount = 'currentAccount',
	nomenclature = 'nomenclature',
	redirectUrl = 'redirectUrl',
	mapLanguage = 'mapLanguage',
	transactionsDateFilter = 'transactionsDateFilter',
	OilWalletsUserId = 'OilWalletsUserId',
	allClients = 'allClients',
	selectedClient = 'selectedClient',
	tableConfig = 'tableConfig',
}
